// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2DSBA","disabled":"FileBtn_disabled__1xv5C","warn":"FileBtn_warn__6x9kB","fade":"FileBtn_fade__3l07x"};